import React from "react";
import { ImageContainer, Image } from "../styles/components/Global/Global";

const LotusLogo = ({ source, margin, small, link }) => {
  return link ? (
    <a
      href="https://www.lotuscars.com/eletre?utm_source=editorial23&utm_medium=PARTNERWEBSITE&utm_campaign=ELETRE_NA_Influencer_Q3_23&utm_content=HS-editorial"
      target="_blank"
    >
      <ImageContainer $margin={margin}>
        <Image src={source} $small={small} />
      </ImageContainer>
    </a>
  ) : (
    <ImageContainer $margin={margin}>
      <Image src={source} $small={small} />
    </ImageContainer>
  );
};

LotusLogo.defaultProps = {
  margin: false,
  small: false,
  link: false,
};

export default LotusLogo;
